export const VisitorStatus = {
    List: [
        {label: "VMS_REQUEST_VISITOR_STATUS_VISIT_WAITING", value: "00"},
        {label: "VMS_REQUEST_VISITOR_STATUS_CHECK_IN_PENDING", value: "01"},
        {label: "VMS_REQUEST_VISITOR_STATUS_CHECK_IN", value: "02"},
        {label: "VMS_REQUEST_VISITOR_STATUS_CHECK_OUT", value: "03"},
        {label: "VMS_REQUEST_VISITOR_STATUS_CHECK_IN_REJECT", value: "04"},
        {label: "VMS_REQUEST_VISITOR_STATUS_EXPIRED", value: "20"},
        {label: "VMS_REQUEST_VISITOR_STATUS_CANCEL", value: "21"},
    ],
    Map: new Map<string, string>([
        ['00', 'VMS_REQUEST_VISITOR_STATUS_VISIT_WAITING'],
        ['01', 'VMS_REQUEST_VISITOR_STATUS_CHECK_IN_PENDING'],
        ['02', 'VMS_REQUEST_VISITOR_STATUS_CHECK_IN'],
        ['03', 'VMS_REQUEST_VISITOR_STATUS_CHECK_OUT'],
        ['04', 'VMS_REQUEST_VISITOR_STATUS_CHECK_IN_REJECT'],
        ['20', 'VMS_REQUEST_VISITOR_STATUS_EXPIRED'],
        ['21', 'VMS_REQUEST_VISITOR_STATUS_CANCEL'],
    ]),
    Enum: {
        Default: '00',
        WaitingCheckIn: '01',
        CheckIn: "02",
        CheckOut: '03',
        CheckInReject: '04',
        Expired: '20',
        Cancel: '21'
    }
};